import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AdvancedsearchComponent } from '../../../pages/advancedsearch/advancedsearch.component';
import { SetComponentsService } from '../../../services/edit/set-components.service';
import { PredefinedTemplatesService } from '../../../services/edit/predefined-templates.service';
import { SharedService } from './../../../services/shared/shared.service';
import { LayoutService } from '../../../services/layout.service';
import { SidenavContent } from '../../side-nav/sidenav-content';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'edit-c-topic',
  templateUrl: './edit-c-topic.component.html',
  styleUrls: ['./edit-c-topic.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class EditCTopicComponent extends SidenavContent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('advanceShowcase') advanceShowcase: AdvancedsearchComponent;
  @ViewChild('chipLabel') chipLabel: ElementRef;
  @Input() template: any;
  @Input() rowType: any;
  @Input() rowArray: any;
  @Input() compArray: any;
  @Input() topic: any;
  @Input() edit: boolean;
  Topic: any;
  temp: any;
  recordsCount: number;
  libArray: any = [];
  // Form Variables
  typeOf: any;
  title: any;
  color: any;
  background: any;
  topicColor: any = 'var(--link)';
  topicBack: any = '#fafafa';
  flushed = false;
  eachRow = false;
  hoverTheme = true;
  className: string;
  rowChips: any = [];
  // Search Variables
  libraries = true;
  lang = false;
  pubYears = true;
  formats = true;
  matTypes = true;
  audience = true;
  reading = true;
  interest = false;
  point = true;
  lexile = true;
  dateAdded = true;
  SearchTopic: any;
  position: any;
  chipEdit: any;
  showAddTopic = true;
  clear = false;

  // Responsive Column Variables.
  OneColumn: boolean;
  TwoColumns: boolean;
  ThreeColumns: boolean;
  FourColumns: boolean;
  FiveColumns: boolean;
  SixColumns: boolean;
  panelOneOpenState = true;
  panelTwoOpenState = false;
  isCollapsed = true;
  prevRowArr: any;
  prevCompArr: any;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  pageIdEdit: any;

  private _destroyed$ = new Subject<void>();

  constructor(
    private _layoutService: LayoutService,
    private _editService: SetComponentsService,
    private _predefinedTemplatesService: PredefinedTemplatesService,
    private _sharedService: SharedService,
  ) {
    super(_layoutService);
  }

  ngOnInit() {
    // get pageIdEdit from home-edit set
    // this variable states whether the page is new create edit or existing page edit
    this._predefinedTemplatesService
      .getPageIdEditBS()
      .pipe(takeUntil(this._destroyed$))
      .subscribe((id) => {
        this.pageIdEdit = id;
      });
  }
  ngOnChanges(changes: SimpleChanges) {
    this.temp = this.template;
    if (this.edit === true) {
      this.setRowType();
      this.getFormVariables();
    } else {
      this.setNewVariables();
    }
    this.SearchTopic = this.temp[this.compArray];
    this.rowChips = this.SearchTopic.rowChips ?? [];
    this.clear = true; // clear the topic search queries in advanced search screen
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  //      ---------------------------------------------------------------------------
  //      -----------------   Setting/Getting Local Variables   ---------------------
  //      ---------------------------------------------------------------------------
  setNewVariables() {
    switch (this.rowType) {
      case 'col-2':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-21':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-2-1-2':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-2-1-3':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-2-2-1':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-2-3-1':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-31':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-3-1-1-2':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-3-1-2-1':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-3-2-1-1':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-42':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-421':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-51':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      case 'col-632':
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
      default:
        this.flushed = true;
        this.color = '';
        this.background = '';
        this.topicColor = '';
        this.topicBack = '';
        this.hoverTheme = false;
        this.eachRow = false;
        this.className = 'padding-25';
        break;
    }
  }
  getFormVariables() {
    // Form Variables
    this.title = this.temp[this.compArray].title;
    this.background = this.temp[this.compArray].background;
    this.color = this.temp[this.compArray].color;
    this.flushed = this.temp[this.compArray].flushed;
    this.className = this.temp[this.compArray].className;
    this.topicColor = this.temp[this.compArray].topicColor;
    this.topicBack = this.temp[this.compArray].topicBack;
    this.eachRow = this.temp[this.compArray].eachRow;
    this.hoverTheme = this.temp[this.compArray].hoverTheme;
    // needs search to input this variable for submission.
    this.rowChips = this.temp[this.compArray].rowChips;
  }
  setRowType() {
    // Just in case values are null, pre-populate.
    switch (this.rowType) {
      case 'col-2':
        this.className = 'padding-25';
        break;
      case 'col-21':
        this.className = 'padding-25';
        break;
      case 'col-2-1-2':
        this.className = 'padding-25';
        break;
      case 'col-2-1-3':
        this.className = 'padding-25';
        break;
      case 'col-2-2-1':
        this.className = 'padding-25';
        break;
      case 'col-2-3-1':
        this.className = 'padding-25';
        break;
      case 'col-31':
        this.className = 'padding-25';
        break;
      case 'col-3-1-1-2':
        this.className = 'padding-25';
        break;
      case 'col-3-1-2-1':
        this.className = 'padding-25';
        break;
      case 'col-3-2-1-1':
        this.className = 'padding-25';
        break;
      case 'col-42':
        this.className = 'padding-25';
        break;
      case 'col-421':
        this.className = 'padding-25';
        break;
      case 'col-51':
        this.className = 'padding-25';
        break;
      case 'col-632':
        this.className = 'padding-25';
        break;
      default:
        this.className = 'padding-25';
    }
  }

  //      ---------------------------------------------------------------------------
  //      -----------------   Updating and Saving Topic Variables   -----------------
  //      ---------------------------------------------------------------------------
  updateTOPIC() {
    for (let index = 0; index < this.rowChips.length; index++) {
      const element = this.rowChips[index];
      if (Array.isArray(element.description) === false) {
        const dummy = [];
        dummy.push(element.description);
        element.description = dummy;
      }
    }
    const result = {
      typeOf: 'topic',
      title: this.title,
      color: this.color,
      background: this.background,
      topicColor: this.topicColor,
      topicBack: this.topicBack,
      flushed: this.flushed,
      eachRow: this.eachRow,
      hoverTheme: this.hoverTheme,
      className: this.className,
      rowChips: this.rowChips,
    };
    this._editService.setTOPIC(result, this.rowType, this.temp, this.rowArray, this.compArray);
  }
  //
  // Save with a close Sidenav
  //
  submitTOPIC() {
    const result = {
      typeOf: 'topic',
      title: this.title,
      color: this.color,
      background: this.background,
      topicColor: this.topicColor,
      topicBack: this.topicBack,
      flushed: this.flushed,
      eachRow: this.eachRow,
      hoverTheme: this.hoverTheme,
      className: this.className,
      rowChips: this.rowChips,
    };

    if (this.rowChips) {
      if (this.rowChips.length > 0) {
        this._editService.setTOPIC(result, this.rowType, this.temp, this.rowArray, this.compArray);
        this.closeNav();
      } else {
        const message = 'please add a chip name to save';
        this._sharedService.openSnackBar(message, 'ok');
      }
    } else {
      const message = 'please add a chip name to save';
      this._sharedService.openSnackBar(message, 'ok');
    }
  }

  //      ---------------------------------------------------------------------------
  //      -------------------------   UI Elements   ---------------------------------
  //      ---------------------------------------------------------------------------
  recordsFound(event) {
    this.recordsCount = event;
  }

  AddChip(event) {
    const topicQuery = this.advanceShowcase.buildAdvancedSearchRequest();
    this.rowChips.push({
      description: this.chipLabel.nativeElement.value,
      query: topicQuery,
    });
    this.SearchTopic.rowChips = this.rowChips;
    this.chipLabel.nativeElement.value = '';
    this.prevRowArr = this.rowArray;
    this.prevCompArr = this.compArray;
  }

  removeTopic(index) {
    this.SearchTopic.rowChips.splice(index, 1);
  }

  editTopic(topic, position) {
    this.removable = false;
    this.showAddTopic = false;
    topic.position = position;
    this.chipEdit = topic;
  }

  // save an existing editedchip
  saveTopic(event) {
    const pos = event.position;
    const chip = {
      query: event.query,
      description: event.description,
      position: event.position,
    };
    for (let index = 0; index < this.rowChips.length; index++) {
      // get the row chips array
      if (index === pos) {
        this.rowChips.splice(pos, 1, chip);
      }
    }
    this.SearchTopic.rowChips = this.rowChips; // place the chips array in display
    this.removable = true;
    this.showAddTopic = true;
  }
}
